import * as React from 'react';
import Masonry from 'react-masonry-component';
import styles from './Gallery.module.scss';

var BPImage = null;
  
const masonryOptions = {
    transitionDuration: 0
};
 
const imagesLoadedOptions = { background: '.my-bg-image-el' }
 
export default class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = { bpLoaded: false };
  }
  componentDidMount() {
    if (typeof window !== `undefined`) {
        import('bigpicture-react')
        .then((bigpicture) => {
           BPImage = bigpicture.BPImage;
           this.setState({ bpLoaded: true });
        });
    }
  }
  
  render() {
    let children = React.Children.toArray(this.props.children);
    
    const childElements = children.map((image, index) => (
       <li key={image.props.src} className={styles.image}>
        {BPImage &&
          <BPImage src={image.props.src}>
            <img src={image.props.thumb} alt={image.props.alt} />
          </BPImage>
        }
       </li>
     ));
     
     return (
       <Masonry
         className={styles.wrapper} // default ''
         elementType={'ul'} // default 'div'
         options={masonryOptions} // default {}
         disableImagesLoaded={false} // default false
         updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
         imagesLoadedOptions={imagesLoadedOptions} // default {}
       >
         {childElements}
       </Masonry>
     );
   }
}
 